import React, { useRef } from 'react';
import { useOnClickOutside } from '../hooks/useOnClickOutside';
import config from '../config/config';

const STYLES = {
  boundary: config.map.styles.boundary,
  boundaryLabel: config.map.styles.boundaryLabel,
  street: config.map.styles.street,
  streetLabel: config.map.styles.streetLabel,
  terrain: config.map.styles.terrain,
  terrainLabel: config.map.styles.terrainLabel,
  kana: config.map.styles.kana,
  kanaLabel: config.map.styles.kanaLabel,
  default: config.map.defaultStyleName,
  defaultLabel: config.map.defaultStyleLabel,
}

const ICON_PNG_URLS = {
  boundary: `${config.icons.pngsBaseUrl}${config.icons.boundary}`,
  street: `${config.icons.pngsBaseUrl}${config.icons.streetName}`,
  terrain: `${config.icons.pngsBaseUrl}${config.icons.topography}`,
  kana: `${config.icons.pngsBaseUrl}${config.icons.hiragana}`,
  default: `${config.icons.pngsBaseUrl}${config.icons.default}`,
};

const DESCRIPTION_BACKGROUND_LAYER = '背景地図';

/**
 * レイヤーポップアップコンポーネント
 */
const LayerPopup = ({
  isLayerPopupOpen,
  onCloseLayerPopup,
  onStyleChange,
  currentStyleName
}) => {

  // クリックしたDOMがこの要素の内側か？を判定するため
  const containerRef = useRef(null);

  // 外側クリックで閉じる（レイヤーボタン上のクリックは無視）
  useOnClickOutside({
    // 内側判定の基準となる要素のref
    containerRef,
    // 外側クリックだった場合に実行する関数
    onOutside: onCloseLayerPopup,
    // trueのときだけ有効化
    enabled: isLayerPopupOpen,
    // ここをクリックした場合は無視するセレクタ群（挙動と外側判定の干渉避け）
    ignoreSelectors: ['#layer-toggle-btn'],
  });

  // スタイル選択時
  const handleStyleChange = (style) => {
    // 親から渡されたonStyleChangeを呼び出し
    onStyleChange(style);
    // スタイル変更後にポップアップを閉じる
    onCloseLayerPopup();
  };

  const itemClass = (styleName) => {
    // 現在選択中のスタイルならselectedクラスを付与
    if (currentStyleName === styleName) {
      return 'layer-item selected';
    }
    // 選択中でなければ通常表示
    return 'layer-item';
  };

  // Hookの呼び出し順を守るため、return nullは最後にする
  if (!isLayerPopupOpen) return null;

  return (
    <div className="layer-popup" ref={containerRef}>
      <div className="layer-popup-content">
        <button className="close-btn" onClick={onCloseLayerPopup}>&times;</button>
        <div className="layer-options">

          {/* // モバイル端末で非表示にするボタンについてはlayer-popup.cssで指定(max-width: 768px） */}
          <h4>{DESCRIPTION_BACKGROUND_LAYER}</h4>
          <div className="layer-grid">
            <div
              className={itemClass(STYLES.default)}
              data-style={STYLES.default}
              onClick={() => handleStyleChange(STYLES.default)}
            >
              <div
                className="layer-preview"
                style={{ backgroundImage: `url('${ICON_PNG_URLS.default}')` }}
              ></div>
              <span className="layer-name">{STYLES.defaultLabel}</span>
            </div>

            <div
              className={itemClass(STYLES.boundary)}
              data-style={STYLES.boundary}
              onClick={() => handleStyleChange(STYLES.boundary)}
            >
              <div
                className="layer-preview"
                style={{ backgroundImage: `url('${ICON_PNG_URLS.boundary}')` }}
              ></div>
              <span className="layer-name">{STYLES.boundaryLabel}</span>
            </div>

            <div
              className={itemClass(STYLES.street)}
              data-style={STYLES.street}
              onClick={() => handleStyleChange(STYLES.street)}
            >
              <div
                className="layer-preview"
                style={{ backgroundImage: `url('${ICON_PNG_URLS.street}')` }}
              ></div>
              <span className="layer-name">{STYLES.streetLabel}</span>
            </div>

            <div
              className={itemClass(STYLES.terrain)}
              data-style={STYLES.terrain}
              onClick={() => handleStyleChange(STYLES.terrain)}
            >
              <div
                className="layer-preview"
                style={{ backgroundImage: `url('${ICON_PNG_URLS.terrain}')` }}
              ></div>
              <span className="layer-name">{STYLES.terrainLabel}</span>
            </div>

            <div
              className={itemClass(STYLES.kana)}
              data-style={STYLES.kana}
              onClick={() => handleStyleChange(STYLES.kana)}
            >
              <div
                className="layer-preview"
                style={{ backgroundImage: `url('${ICON_PNG_URLS.kana}')` }}
              ></div>
              <span className="layer-name">{STYLES.kanaLabel}</span>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default LayerPopup;